import ElectronicBillsPage from "./ElectronicBillsPage";

export default ElectronicBillsPage;
